import React from "react";
import '../../Styles/Offer.css'

// const products = [
//   {
//     id: 1,
//     img: "/asset/img/Ecom/4.png",
//     title: "TRI COLOR INDIAN JERSEY",
//     oldPrice: 899,
//     newPrice: 699,
//   },
//   {
//     id: 2,
//     img: "/asset/img/Ecom/4.png",
//     title: "2023 INDIAN FAN JERSEY",
//     oldPrice: 799,
//     newPrice: 687,
//   },
//   {
//     id: 3,
//     img: "/asset/img/Ecom/4.png",
//     title: "1999 INDIAN RETRO JERSEY",
//     oldPrice: 899,
//     newPrice: 699,
//   },
//   {
//     id: 4,
//     img: "/asset/img/Ecom/4.png",
//     title: "Jersey 4",
//     oldPrice: 850,
//     newPrice: 750,
//   },
//   {
//     id: 5,
//     img: "/asset/img/Ecom/4.png",
//     title: "Jersey 5",
//     oldPrice: 900,
//     newPrice: 800,
//   },
//   {
//     id: 6,
//     img: "/asset/img/Ecom/4.png",
//     title: "Jersey 6",
//     oldPrice: 950,
//     newPrice: 850,
//   },
// ];

const images = [
    { id: 1, src:  "/asset/img/Ecom/30.png", alt: 'Image 1' },
    { id: 2, src:  "/asset/img/Ecom/8.png", alt: 'Image 2' },
    { id: 3, src:  "/asset/img/Ecom/15.png", alt: 'Image 3' },
    { id: 4, src:  "/asset/img/Ecom/21.png", alt: 'Image 4' },
    { id: 5, src:  "/asset/img/Ecom/22.png", alt: 'Image 5' },
    { id: 6, src:  "/asset/img/Ecom/27.png", alt: 'Image 6' },
    { id: 7, src:  "/asset/img/Ecom/34.png", alt: 'Image 7' },
  ];

// const products = [
//     {
//       id: 1,
//       name: 'TRI COLOR INDIAN JERSEY',
//       price: { original: 899, discounted: 699 },
//       images: ['/asset/img/Ecom/30.png', '/asset/img/Ecom/8.png'],
//       offer: true,
//       latest: true,
//       customizable: false,
//     },
//     {
//       id: 2,
//       name: '2023 INDIAN FAN JERSEY',
//       price: { original: 799, discounted: 687 },
//       images: ['/asset/img/Ecom/15.png', '/asset/img/Ecom/21.png'],
//       offer: true,
//       latest: true,
//       customizable: false,
//     },
//     {
//       id: 3,
//       name: '1999 INDIAN RETRO JERSEY',
//       price: { original: 899, discounted: 699 },
//       images: ['/asset/img/Ecom/22.png', '/asset/img/Ecom/27.png'],
//       offer: true,
//       latest: true,
//       customizable: false,
//     },
//     {
//       id: 4,
//       name: 'CHENNAI FAN JERSEY',
//       price: { original: 799, discounted: 599 },
//       images: ['/asset/img/Ecom/34.png', '/asset/img/Ecom/30.png'],
//       offer: true,
//       latest: true,
//       customizable: false,
//     },
//     {
//       id: 5,
//       name: 'MIDNIGHT BLUE WOMEN’S RUN X JERSEY',
//       price: { original: 599, discounted: 549 },
//       images: ['/asset/img/Ecom/8.png', '/asset/img/Ecom/15.png'],
//       offer: true,
//       latest: true,
//       customizable: false,
//     },
//     {
//       id: 6,
//       name: 'BEVISIBLE PATTERN CYCLING JERSEY',
//       price: { original: 1925, discounted: 1249 },
//       images: ['/asset/img/Ecom/21.png', '/asset/img/Ecom/22.png'],
//       offer: true,
//       latest: true,
//       customizable: true,
//     },
//   ];

const Offers = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-center text-2xl font-bold mb-6">EXCITING OFFERS</h2>
      <div className="container">
      <div className="left-image">
        <img src={images[0].src} alt={images[0].alt} />
      </div>
      <div className="right-images">
        {images.slice(1).map((image) => (
          <div key={image.id} className="image-item">
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>
    </div>
    </div>
//     <div className="ex-offers padding">
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-md-12 text-center">
//           <div className="title">
//             <h2>EXCITING OFFERS</h2>
//           </div>
//         </div>
//       </div>
//       <div className="row">
//         <div className="col-lg-4">
//           <div className="sale-banner">
//             <a href="https://hyvesports.com/product-category/shop-by-sports/fitness/">
//               <img decoding="async" className="lazy" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="https://cdn.hyvesports.com/wp-content/uploads/2023/08/creativ-1.jpg" alt="" />
//             </a>
//           </div>
//         </div>
//         <div className="col-lg-8">
//           <div className="row">
//             {products.map((product) => (
//               <div key={product.id} className="col-md-4 col-6">
//                 <div className="product-style">
//                   <div className="product-top">
//                     {product.offer && <div className="latest lazy-bg"><p>Offer</p></div>}
//                     {product.latest && <div className="latest mglts lazy-bg"><p>Latest</p></div>}
//                     <div className="edit">
//                       <img className="lazy" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src={product.customizable ? "https://cdn.hyvesports.com/wp-content/themes/hyvesports/images/full-customization-1.png" : "https://cdn.hyvesports.com/wp-content/themes/hyvesports/images/no-customization.png"} alt="" />
//                     </div>
//                     <div className="edit on-hover">
//                       <img className="lazy" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src={product.customizable ? "https://cdn.hyvesports.com/wp-content/themes/hyvesports/images/full-customization-1.png" : "https://cdn.hyvesports.com/wp-content/themes/hyvesports/images/no-customization.png"} alt="" />
//                       {product.customizable ? 'Fully Customizable' : 'Not Customizable'}
//                     </div>
//                   </div>
//                   <a href={`https://hyvesports.com/product/${product.name.toLowerCase().replace(/ /g, '-')}/`} className="img-product-a">
//                     <div className="product-img">
//                       <img className="lazy first_image" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src={product.images[0]} alt={product.name} />
//                       <img className="lazy second_image" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" style={{ display: 'none' }} data-src={product.images[1]} alt={product.name} />
//                     </div>
//                   </a>
//                   <div className="bottom-latest-only">
//                     {product.offer && <div className="latest lazy-bg"><p>Offer</p></div>}
//                     {product.latest && <div className="latest mglts lazy-bg"><p>Latest</p></div>}
//                   </div>
//                   <div className="product-bottom">
//                     <div className="hover-none">
//                       <h3>{product.name}</h3>
//                     </div>
//                     <div className="flex-p-btn">
//                       <p className="price">
//                         <del aria-hidden="true"><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">&#8377;</span>{product.price.original}</bdi></span></del>
//                         <ins><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">&#8377;</span>{product.price.discounted}</bdi></span></ins>
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="row">
//         <div className="col-md-12 text-center">
//           <a href="https://hyvesports.com/product-category/exciting-offers/" className="btn-style">View All</a>
//         </div>
//       </div>
//     </div>
//   </div>

  );
};

export default Offers;
